import React, { useState, useEffect } from 'react';
import { RefreshCw, WifiOff } from 'lucide-react';
import offlineDB from '../utils/offlineDB';

export const SyncStatusBadge = () => {
  const [pendingCount, setPendingCount] = useState(0);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const updatePendingCount = async () => {
      try {
        const queue = await offlineDB.getSyncQueue();
        setPendingCount(queue.length);
      } catch (error) {
        console.error('Error getting sync queue:', error);
      }
    };

    // Actualizar cada 3 segundos
    const interval = setInterval(updatePendingCount, 3000);
    updatePendingCount();

    const handleOnline = () => {
      setIsOnline(true);
      // Cuando vuelve conexión, el hook principal sincronizará automáticamente
      setTimeout(updatePendingCount, 2000); // Actualizar después de sync
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      clearInterval(interval);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // No mostrar si no hay cambios pendientes y estamos online
  if (pendingCount === 0 && isOnline) return null;

  return (
    <div className="flex items-center gap-2">
      {!isOnline && (
        <div className="flex items-center gap-1 px-2 py-1 bg-red-900/30 border border-red-700/50 rounded text-xs text-red-300">
          <WifiOff className="w-3 h-3" />
          <span>Offline</span>
        </div>
      )}
      
      {pendingCount > 0 && (
        <div className="flex items-center gap-1 px-2 py-1 bg-amber-900/30 border border-amber-700/50 rounded text-xs text-amber-300 animate-pulse">
          <RefreshCw className="w-3 h-3" />
          <span>{pendingCount} pendiente{pendingCount !== 1 ? 's' : ''}</span>
        </div>
      )}
    </div>
  );
};
